import './index.scss'
// import '../../assets/scripts/myNiceScroll'
// import {resizeScroll} from '../../assets/scripts/myNiceScroll'
import 'bootstrap/dist/js/bootstrap.min'
import 'eonasdan-bootstrap-datetimepicker/build/js/bootstrap-datetimepicker.min.js'

$('#date').datetimepicker({
  viewMode: "years",
  locale: 'zh-cn',
  format: 'YYYY-MM-DD',
  ignoreReadonly: true,
  showClear: true
})

$('.select input').on('click',function(){
  let $parent = $(this).closest('.select')
  if(!$parent.hasClass('hover')){
    $parent.addClass('hover')
  }
})

$('.select .select-list li').on('click',function(){
  let that = $(this)
  let val = $(this).html()
  that.closest('.select').find('input').val(val)
  that.closest('.select').removeClass('hover')
  
  setTimeout(function(){
    that.addClass('on').siblings().removeClass('on')
  },200)
})

$('body').on('click',function(e){
  if($(e.target).parents('.form-item .select').length == 0){
    $('.form-item .select').removeClass('hover')
  }
})